import React, { HTMLAttributes } from "react"

export const ExternalLink = ({
  href,
  children,
  className,
  ...props
}: ExternalLinkProps) => {
  return (
    // @ts-ignore
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={href}
      className={className}
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    >
      {children}
    </a>
  )
}

export type ExternalLinkProps = HTMLAttributes<HTMLAnchorElement> & {
  href: string
  className?: string
  children: React.ReactNode
}
